import { render, staticRenderFns } from "./SidebarUpdateUser.vue?vue&type=template&id=120f7960"
import script from "./SidebarUpdateUser.vue?vue&type=script&lang=js"
export * from "./SidebarUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports